import $ from 'jquery'
import swal from 'sweetalert2'

const INACTIVE_AT_SECONDS = 3600
const LOGOUT_AFTER_SECONDS = 10
let inactivityTimer
let logoutInterval

function doLogout() {
  window.location.href = window.APP.urls.logout
}

function keepalive() {
  // eslint-disable-next-line no-use-before-define
  resetInactivityTimer()

  $.ajax({
    type: 'POST',
    url: window.APP.urls.keepalive,
  })
}

function cancelLogoutCountdown() {
  clearInterval(logoutInterval)
  logoutInterval = 0
}

function startLogoutCountdown() {
  let timeRemaining = LOGOUT_AFTER_SECONDS

  logoutInterval = setInterval(() => {
    const remainingEl = document.querySelector('.auto-signout-time-remaining')
    remainingEl.innerHTML = timeRemaining
    timeRemaining -= 1

    if (timeRemaining <= 0) {
      cancelLogoutCountdown()
      swal.close()
      doLogout()
    }
  }, 1000)
}

function startInactivityTimer() {
  if (logoutInterval) return

  inactivityTimer = setTimeout(() => {
    swal({
      type: 'warning',
      title: 'Inactivity',
      html: `Signing out in <span class="auto-signout-time-remaining">${LOGOUT_AFTER_SECONDS}</span> seconds`,
      showCancelButton: true,
      confirmButtonText: 'Stay signed in',
      cancelButtonText: 'Sign out',
      allowOutsideClick: false,
    }).then((result) => {
      cancelLogoutCountdown()
      if (!result.value) {
        doLogout()
      } else {
        keepalive()
      }
    })

    startLogoutCountdown()
  }, INACTIVE_AT_SECONDS * 1000)
}

function resetInactivityTimer() {
  clearTimeout(inactivityTimer)
  inactivityTimer = 0
  startInactivityTimer()
}

export { keepalive, startInactivityTimer, resetInactivityTimer }
